// REFACTORED: 2026-02-02
// FROM src/components/Utilization/OrgAnalytics.tsx

// ============================================================================
// BUSINESS UNIT CONSTANTS
// ============================================================================

/**
 * Business Unit display order for organizational analytics
 * Business units should be displayed in this specific order
 */
export const BU_ORDER = [
  'Delivery | Cloud Engineering',
  'Delivery | Data Engineering',
  'Delivery | Cloud Security & Reliability Engineering',
  'Delivery | Decision Intelligence Engineering',
  'Delivery | Modern Product Engineering',
  'Delivery | Modern Work Ops Engineering',
  'Delivery | AI Engineering',
  'Client Success',
  'Client Innovation & Capabilities',
];

/** Exact `role.name` from `GET /user/me` for Client Success regional managers (My Team anomalies tab). */
export const CLIENT_SUCCESS_REGIONAL_MANAGER_ROLE = 'Client Success | Regional Manager';

